
import request from '../utils/request'


//登入
export function sendLogin(data) {
	return request({
		url: '/api/user/loginByPwd', 
		method: 'post',
		data: data
	})
}
export function sendContactUs(data) {
	return request({
		url: 'api/webContactUs/add', 
		method: 'post',
		data: data,
		headers: {
			'Content-Type': 'application/json',
			'accept': '*/*'
		}
	})
}

// 门店列表 ß
export function getStoreList(query) {
	return request({
		url: '/api/webStoreInfo/list',
		method: 'get',
		params: query
	})
}

// 轮播图列表
export function getcarousellist(query) {
	return request({
		url: '/api/websiteCarousel/list',
		method: 'get',
		params: query
	})
}

// 新闻栏目列表
export function getapinewschannellist(query) {
	return request({
		url: '/api/websiteNewsChannel/list',
		method: 'get',
		params: query
	})
}

// 新闻列表
export function getapinewslist(query) {
	return request({
		url: '/api/websiteNews/list',
		method: 'get',
		params: query
	})
}

//人才共享-列表
export function getpersonnelSharing(query) {
	return request({
		url: '/api/personnelSharing/list',
		method: 'get',
		params: query
	})
}
//人才共享-删除
export function delpersonnelSharing(query) {
	return request({
		url: '/api/personnelSharing/'+query.id,
		method: 'delete',
		params: query
	})
}
//人才共享-详情
export function getpersonnelSharingdetail(query) {
	return request({
		url: '/api/personnelSharing/'+query.id,
		method: 'get',
		params: query
	})
}
//人才共享-新增
export function addpersonnelSharing(data) {
	return request({
		url: '/api/personnelSharing',
		method: 'post',
		data: data
	})
}
//人才共享-修改
export function editpersonnelSharing(data) {
	return request({
		url: '/api/personnelSharing',
		method: 'put',
		data: data
	})
}
//岗位共享
export function getjobSharing(query) {
	return request({
		url: '/api/jobSharing/list', 
		method: 'get',
		params: query
	})
}
//岗位共享-删除
export function deljobSharing(query) {
	return request({
		url: '/api/jobSharing/'+query.id,
		method: 'delete',
		params: query
	})
}
//岗位共享-详情
export function getjobSharingdetail(query) {
	return request({
		url: '/api/jobSharing/'+query.id,
		method: 'get',
		params: query
	})
}
//岗位共享-新增
export function addjobSharing(data) {
	return request({
		url: '/api/jobSharing',
		method: 'post',
		data: data
	})
}
//岗位共享-修改
export function editjobSharing(data) {
	return request({
		url: '/api/jobSharing',
		method: 'put',
		data: data
	})
}
//人才库
export function getTalentPoolList(query) {
	return request({
		url: '/api/talentPool/list', 
		method: 'get',
		params: query
	})
}
export function getTalentPoolDetail(query) {
	return request({
		url: '/api/talentPool/'+query.id,
		method: 'get',
		params: query
	})
}
export function editTalentPool(data) {
	return request({
		url: '/api/talentPool',
		method: 'put',
		data: data
	})
}
export function addTalentPool(data) {
	return request({
		url: '/api/talentPool',
		method: 'post',
		data: data
	})
}

export function getapinewsdetail(query) {
	return request({
		url: '/api/websiteNews/' + query.id,
		method: 'get',
		params:query
	})
}

export function sendLoginSms(query) {
	return request({
		url: '/api/sms/loginCode',
		method: 'get',
		params: query
	})
}

//工作经验-列表
export function getworkExperience(query) {
	return request({
		url: '/api/workExperience/listMy',
		method: 'get',
		params: query
	})
}
//工作经验-新增
export function addworkExperience(data) {
	return request({
		url: '/api/workExperience',
		method: 'post',
		data: data
	})
}
//工作经验-编辑
export function editworkExperience(data) {
	return request({
		url: '/api/workExperience',
		method: 'put',
		data: data
	})
}
//工作经验-删除
export function delworkExperience(query) {
	return request({
		url: '/api/workExperience/'+query.id,
		method: 'delete',
		params: query
	})
}
//工作经验-获取单个
export function getworkExperienceDetail(query) {
	return request({
		url: '/api/workExperience/'+query.id,
		method: 'get',
		params: query
	})
}

// 查询OSS对象基于id串
export function listByIds(ossId) {
  return request({
    url: '/api/common/listFileByIds/' + ossId,
    method: 'get'
  });
}

// 删除OSS对象存储
export function delOss(ossId) {
  return request({
    url: '/api/oss/' + ossId,
    method: 'delete'
  });
}

//用户列表
export function getUserList(query) {
	return request({
		url: '/api/user/list',
		method: 'get',
		params: query
	})
}
//用户 详情
export function getUsereDetail(query) {
	return request({
		url: '/api/user/'+query.id,
		method: 'get',
		params: query
	})
}
//用户 详情
export function getUsereDetailMy(query) {
	return request({
		url: '/api/user/detailMy/'+query.id,
		method: 'get',
		params: query
	})
}
export function editUser(data) {
	return request({
		url: '/api/user',
		method: 'put',
		data: data
	})
}
export function addUser(data) {
	return request({
		url: '/api/user',
		method: 'post',
		data: data
	})
}

//证照 列表
export function getidentityPhotoList(query) {
	return request({
		url: '/api/identityPhoto/listMy',
		method: 'get',
		params: query
	})
}
export function addidentityPhoto(data) {
	return request({
		url: '/api/identityPhoto',
		method: 'post',
		data: data
	})
}
export function editidentityPhoto(data) {
	return request({
		url: '/api/identityPhoto',
		method: 'put',
		data: data
	})
}
export function deleteidentityPhoto(query) {
	return request({
		url: '/api/identityPhoto/'+query.id,
		method: 'delete',
		params: query
	})
}
export function getidentityPhoto(query) {
	return request({
		url: '/api/identityPhoto/'+query.id,
		method: 'get',
		params: query
	})
}

//项目共享-列表
export function getProjectSharing(query) {
	return request({
		url: '/api/projectSharing/list',
		method: 'get',
		params: query
	})
}

//项目共享-详情
export function getProjectSharingdetail(query) {
	return request({
		url: '/api/projectSharing/'+query.id,
		method: 'get',
		params: query
	})
}


//全部的友情链接
export function getFriendlyLinklistAll(query) {
	return request({
		url: '/api/websiteFriendlyLink/list',
		method: 'get',
		params: query
	})
}

//公告
export function getsharingMatchResultList(query) {
	return request({
		url: '/api/sharingMatchResult/list',
		method: 'get',
		params: query
	})
}

//注册
export function sendRegister(data) {
	return request({
		url: '/api/user/register',
		method: 'post',
		data: data
	})
}

//忘记密码
export function sendForgetPwd(data) {
	return request({
		url: '/api/user/forgetPwd',
		method: 'post',
		data: data
	})
}

//验证码登录
export function sendLoginBySms(data) {
	return request({
		url: '/api/user/loginBySms',
		method: 'post',
		data: data
	})
}

//简历投递
export function postjobSharingResume(data) {
	return request({
		url: '/api/jobSharingResume',
		method: 'post',
		data: data
	})
}


//获取系统参数配置
export function getConfigByKey(key) {
	return request({
		url: '/api/common/config/' + key,
		method: 'get',
		params: {}
	})
}